export enum LocalStorageTypes {
    USER = 'user',
    FAVORITES = 'favorites'
}
